module.exports = __WEBPACK_EXTERNAL_MODULE_4__;


//////////////////
// WEBPACK FOOTER
// external {"root":"echarts","commonjs2":"echarts","commonjs":"echarts","amd":"echarts"}
// module id = 4
// module chunks = 0